<template>
<div>
	<router-link v-if="!news.onlyVideo" :to="{ name: 'NewsSingle', params: { id: news.id }}" class="news-overview">
		<div class="grid grid--s20 grid--middle">
			<div class="grid__item">

				<div
					class="news-overview__image-wrapper"
					:class="{ 'news-overview__image-wrapper--fallback' : !imageStyles }"
				>
					<div
						class="news-overview__image"
						:style="imageStyles"
					/>
				</div>

			</div>
			<div class="grid__item">

				<div class="news-overview__meta-wrapper">
					<div v-if="isNew" class="news-overview__new-badge">
						<span class="grunticon grunticon--badge--new"></span>
					</div>

					<div v-if="news.date" class="news-overview__meta">
						<div class="grid grid--g8 grid--s0 grid--auto grid--middle">
							<div v-if="news.date" class="grid__item">
								<span class="news-overview__date">{{ news.date | formatDate }}</span>
							</div>
							<div v-if="category" class="grid__item">
								<span>•</span>
							</div>
							<div v-if="category" class="grid__item">
								<span class="news-overview__category">{{ category.name }}</span>
							</div>
						</div>
					</div>
					<div
						v-if="news.title"
						class="news-overview__title"
						v-html="news.title"
					/>
					<div
						v-if="news.summary && showSummary"
						class="news-overview__summary"
						v-html="news.summary"
					/>
				</div>
			</div>

		</div>
	</router-link>
	<div v-else class="news-overview">

		<div class="grid grid--s20 grid--middle">
			<div class="grid__item">

				<div :class="'popover=true wistia_embed wistia_async_' + news.videoId"
								style="height:200px; width: 100%; object-fit: cover">
				</div>

			</div>
			<div class="grid__item">

				<div class="news-overview__meta-wrapper">
					<div v-if="isNew" class="news-overview__new-badge">
						<span class="grunticon grunticon--badge--new"></span>
					</div>

					<div v-if="news.date" class="news-overview__meta">
						<div class="grid grid--g8 grid--s0 grid--auto grid--middle">
							<div v-if="news.date" class="grid__item">
								<span class="news-overview__date">{{ news.date | formatDate }}</span>
							</div>
							<div v-if="category" class="grid__item">
								<span>•</span>
							</div>
							<div v-if="category" class="grid__item">
								<span class="news-overview__category">{{ category.name }}</span>
							</div>
						</div>
					</div>
					<div
						v-if="news.title"
						class="news-overview__title"
						v-html="news.title"
					/>
					<div
						v-if="news.summary && showSummary"
						class="news-overview__summary"
						v-html="news.summary"
					/>
				</div>
			</div>

		</div>
	</div>
</div>
</template>

<script>

export default {
	name: 'NewsOverview',
	props: {
		news: {
			type: Object,
			default: null
		},
		category: {
			type: Object,
			default: null
		},
		showSummary: {
			type: Boolean,
			default: true
		},
		isNew: {
			type: Boolean,
			default: false
		},
		imageClickable: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		imageStyles: function () {
			return this.news && this.news.imageLarge && this.news.imageLarge.link ? { backgroundImage: `url('${this.news.imageLarge.link}')` } : null
		},
	},
	mounted: function () {
		let scriptOne = document.createElement('script')
		scriptOne.setAttribute('src', '//fast.wistia.com/embed/medias/' + this.news.videoId + '.jsonp')
		document.head.appendChild(scriptOne)

		let scriptTwo = document.createElement('script')
		scriptTwo.setAttribute('src', '//fast.wistia.com/assets/external/E-v1.js')
		document.head.appendChild(scriptTwo)
	},
	methods: {
		onClick () {
			if (this.news && this.news.content[0].type === 'link') {
				this.trackEvent([
					'news-link-clicked',
					this.news.content[0].url,
					this.$root.$data.user ? this.$root.$data.user.trackName : null,
					0,
					false
				])
			}
		}
	}
}
</script>

<style lang="scss">
@import "src/scss/toolkit";

$c: ".news-overview";
#{$c} {
	position: relative;

	&__image-wrapper {
		position: relative;
		display: block;
		text-align: center;
		border-radius: 4px;
		overflow: hidden;
		background-color: #fff;
		box-shadow: 0 2px 5px rgba(0,0,0,0.1);

		&--fallback {
			@include extend(bg-fill);
			background-image: url('../../assets/img/news/fallback.jpg');
		}

		> *,
		&:before {
			display: inline-block;
			vertical-align: middle;
		}

		&:before {
			position: relative;
			z-index: 1;
			content: "";
			width: 0;
			padding-top: 100% * (272/376);
		}
	}

	&__image {
		display: block;
		@include extend(bg-fill);
		@include extend(absolute-fill);
		background-position: center center;
	}

	&__image-action {
		width: rem(60);
		height: rem(60);
	}

	&__new-badge {
		margin-bottom: rem(16);
	}

	&__meta {
		color: palette('light-grey');
		font-size: rem(14);
		margin-bottom: rem(4);
	}

	&__title {
		@include extend(h5);
		@include extend(heading--black);

		&:not(:last-child) {
			margin-bottom: rem(8);
		}
	}

	&__summary {
		color: palette('grey');
		font-size: rem(16);
		line-height: (26/16);
	}

	&__category {
		display: inline-block;
		// color: palette(link);
	}
}
.grid--s20 > div.grid__item:first-child {
    margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/NewsOverview.vue